export enum PersonalNoteTargetType {
    MeetingItem = "meetingItem",
    QuickTask = "quickTask",
    CoachingTask = "coachingTask",
}

/**
 * Personal Note - user-private notes attached to a single task-like entity.
 * Notes are stored separately from shared meeting/task documents so they stay private.
 */
export interface PersonalNote {
    id?: string;
    createdBy?: string;
    targetType: PersonalNoteTargetType;
    targetId: string;
    meetingId?: string;
    sessionId?: string;
    clientId?: string;
    content: string;
    createdDate?: Date;
    updatedDate?: Date;
    archived?: boolean;
}

export const isPersonalNoteForTarget = (
    note: PersonalNote,
    targetType: PersonalNoteTargetType,
    targetId?: string | null,
): boolean =>
    !!targetId
    && note.targetType === targetType
    && note.targetId === targetId;

export const countPersonalNotesForTarget = (
    notes: PersonalNote[],
    targetType: PersonalNoteTargetType,
    targetId?: string | null,
): number =>
    notes.filter((note) => isPersonalNoteForTarget(note, targetType, targetId)).length;
